// Português - pt - 葡萄牙语
const pt = {
  home: {
    home: 'Início',
    solutions: 'Soluções',
    support: 'Suporte',
    news: 'Notícias',
    aboutUs: 'Sobre nós',
    contactUs: 'Contacte-nos',
    cgm: 'CGM',
    download: 'Downloads',
    helpCenter: 'Centro de ajuda',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Todos os direitos reservados.',
    menu: 'Menu',
    quickLinks: 'Ligações rápidas',
    contact: 'Contacto',
    legal: 'Legal',
    termsUse: 'Termos de utilização',
    privacyPolicy: 'Política de privacidade',
    portal: 'Portal do utilizador',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'Email',
    subscribe: 'Subscrever',
    signUp: 'Inscreva-se para receber as últimas notícias',
    downloadApp: 'Descarregar aplicação',
    blogNews: 'Blog e notícias',
    latestArticles: 'Artigos mais recentes',
    viewAllArticles: 'Ver todos os artigos',
    empower: 'Potencie a sua jornada de saúde connosco',
    empowerList1Content:
      'O Hippo CGM tornou muito mais fácil o controlo da diabetes do meu filho. Podemos utilizar o HIPPOLINK para visualizar os seus padrões de glicose com clareza e ajustar o seu tratamento com segurança. Isso dá-nos tranquilidade.',
    empowerList1Name:
      'Petra N., República Checa (mãe de uma criança com diabetes tipo 1)',
    empowerList2Content:
      'Recomendamos o HIPPO CGM aos pacientes devido ao seu desempenho estável e maior tempo de utilização. O feedback dos utilizadores tem sido excelente, especialmente daqueles que procuram uma opção mais acessível.',
    empowerList2Name: 'Dr. Luca B., endocrinologista, Itália',
    empowerList3Content:
      'Comecei a usar o Hippo CGM recentemente — é confortável, preciso e os alertas ajudaram-me a evitar as hipoglicemias durante a noite. Estou muito satisfeita com os resultados até ao momento.',
    empowerList3Name: 'Fahad A., Arábia Saudita (paciente com diabetes tipo 2)',
    reliable: 'O seu parceiro fiável para o controlo da diabetes',
    hippoH1: 'HiPPO H1',
    challenges: 'Desafios',
    constant: 'Monitorização constante da glicose',
    traditional: 'A picada no dedo pode ser dolorosa e inconveniente',
    dataOverload: 'Sobrecarga de dados',
    managing:
      'Gerir os dados de glicose pode ser complexo e de dificil interpretação',
    treatment: 'Ajustes do tratamento',
    accurately:
      'Determinar o tratamento correto baseado nas leituras da glicose pode ser complexo',
    lifestyle: 'Integração no estilo de vida',
    balancing:
      'Equilibrar refeições, exercício e medicação com as atividades diárias pode ser um desafio',
    hippoCan: 'Os biossensores Hippo oferecem',
    painless: 'Monitorização indolor e discreta',
    ourCgm:
      'O nosso CGM fornece medições contínuas sem a necessidade de picar o dedo',
    realTime: 'Dados e insights em tempo real',
    accessYour:
      'Aceda aos seus dados de glicose convenientemente no smartphone, permitindo-lhe ver tendências e tomar decisões informadas',
    personalized: 'Suporte personalizado',
    ourCgmSys:
      'Os alertas e lembretes da aplicação Hippo BioSensors podem ajudá-lo a manter-se em linha com o seu plano de tratamento.',
    improved: 'Melhor tomada de decisão',
    gain: 'Melhor compreensão de como o seu corpo reage aos eventos permitindo-lhe compensar melhor as flutuações da glicose. O feedback em tempo real possibilita ajustes mais eficazes nas suas atividades diárias.',
    // about: 'Sobre',
    companyProfile: 'Perfil da empresa',
    banner1Title: 'Bem-vindo à Hippo Medical',
    banner1Content: 'Na vanguarda da inovação CGM',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Definimos novos padrões',
    banner3Content: 'Proteção contínua da glicose',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Líder em tecnologia CGM',
    // 错误提示
    subscribeSuccess: 'Subscrição bem-sucedida', // ai翻译
    subscribeFailed: 'Subscrição falhou', // ai翻译
    invalidEmail: 'Endereço de email inválido', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return pt.home.banner1Title;
    },
    get banner1Content() {
      return pt.home.banner4Content;
    },
    whyChoose: 'Porquê escolher o HiPPO CGM',
    accurate: 'Precisão em que pode confiar',
    accurateText: 'A tecnologia enzimática de terceira geração oferece',
    accurateText1: 'desempenho estável e preciso',
    easyUse: 'Fácil de usar',
    easyUseText: '14 dias de monitorização contínua',
    realTime: 'Monitorização',
    realTimeText: 'Alertas de hipo e hiperglicemia em tempo real',
    realTimeText1:
      'Partilha de dados em tempo real com a familia & Profissionais de Saúde',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    // keep: 'Mantém-no informado a qualquer momentom qualquer lugar',
    keep: 'Mantenha-se informado em qualquer lugar e a qualquer hora',
    withHippo: 'Com a aplicação e portal HiPPO',
    smallSensors: 'Sensores pequenos, uso confortável',
    agpReport:
      'Relatório AGP profissional permite que os profissionais de saúde e os utilizadores captem as informações essenciais imediatamente.',
    unlimitedFollow:
      'Seguimentos ilimitados capacitam os profissionais de saúde para gerir mais utentes.',
    iWatchApp: 'Aplicação iWatch disponível',
    certified: 'Uso Certificado para crianças',
    loremIp:
      'O sistema está clinicamente validado e oficialmente certificado para uso pediátrico em crianças com mais de 3 anos, garantindo segurança, precisão e conforto aos doentes mais jovens. Com uma precisão comprovada do sensor e materiais suaves e hipoalergénicos, proporcionam uma monitorização fiável da glicose em crianças e adolescentes, auxiliando os profissionais de saúde a oferecerem cuidados de diabetes seguros e baseados em dados.',
  },
  news: {
    date: 'Data',
    recommendedArticles: 'Artigos recomendados',
  },
  support: {
    download: 'Descarregar guias',
    supportDown: 'Suporte/Downloads',
  },
  about: {
    welcome: 'Bem-vindo à Hippo Medical',
    covered: 'Países cobertos',
    patents: 'Patentes',
    features: 'Funcionalidades3',
    ring: 'Anel',
    apparently:
      'Um anel inteligente que monitoriza parâmetros como a oxigenação sanguínea, o ritmo cardíaco e o sono. Mais importante ainda, tem uma ligação algorítmica com o nosso CGM (Monitor Contínuo de Glicose). Lançamento em 2026. Fique atento!',
    cgmSky:
      'Um CGM profissional concebido a pensar tanto na utilização pelo doente como nas necessidades clínicas do médico. Oferece alta precisão, interface amigável e é alimentado pelos algoritmos da Hippo Medical. Lançamento em junho de 2025!',
    smartWatch: 'Relógio inteligente',
    byTheSame:
      'Um dispositivo wearable para monitorização dinâmica da pressão arterial, capaz de rastrear continuamente a pressão sistólica, a pressão diastólica, a pressão arterial média e muito mais, com um algoritmo desenvolvido pela Hippo Medical. Lançamento em 2026. Fique atento!',
    explore: 'Explorar',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'SINGAPURA (409051)',
    zipCode: 'Código postal',
    emailCode: '409051',
    email: 'Email',
    emailText: 'info@hippodiabetes.com',
    name: 'Nome',
    company: 'Empresa',
    message: 'Mensagem',
    phone: 'Telefone',
    submit: 'Submeter',
    commingSoon: 'Em breve',
    cpInfo1:
      'A Hippo Medical é uma empresa global de tecnologia médica, com sede em Singapura, dedicada a revolucionar a gestão de doenças crónicas com biossensores vestíveis de nível médico. A nossa visão é fornecer monitorização contínua e análise avançada de dados.',
    cpInfo2:
      'Ao desenvolver biossensores de última geração e uma plataforma de inteligência de dados de ponta, pretendemos transformar o diagnóstico e abrir caminho para um futuro mais proativo e personalizado.',
    submitFailed: 'Submissão falhou', // ai翻译
    get invalidEmail() {
      return pt.home.invalidEmail;
    },
    fillAllFields: 'Por favor, preencha este campo', // ai翻译
  },
  download: {
    language: 'Idioma',
    product: 'Produto',
    unit: 'Unidade',
    fetchFailed: 'Obtensão falhou', // ai翻译
  },
  help: {
    search: 'Pesquisar',
    support: 'Suporte/Centro de ajuda/H1 CGM',
    source: 'Recursos online HiPPO H1 CGM',
    viewAll: 'Ver todos',
    insert: 'Como inserir o CGM H1',
    setUp: 'Como configurar a aplicação H1',
    faq: 'FAQ CGM HiPPO H1',
    freq: 'Perguntas frequentes',
    noData: 'Nenhum conteúdo encontrado..',
    searchKeys: {
      warmUp: 'Falha na fase de aquecimento',
      waterLeakage: 'Fuga de água',
      lowGlucose: 'Dados de glicose baixa',
      cannotPair: 'Não é possível emparelhar com o smartphone',
    },
  },
  faq: {
    faq: 'FAQ',
    general: 'Perguntas gerais',
    need: 'Precisa de ajuda?',
    here: 'Aqui estão as perguntas mais frequentes',
    technical: 'Perguntas técnicas',
  },
  lang: {
    chooseCountry: 'Escolha o seu país/região',
    northAmerica: 'América do Norte', // ai翻译
    southAmerica: 'América do Sul', // ai翻译
    europe: 'Europa', // ai翻译
    africa: 'África', // ai翻译
    asia: 'Ásia', // ai翻译
    oceania: 'Oceânia', // ai翻译
    other: 'Outros', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Suzhou, China',
      subName: 'Unidade de produção',
      hovData: 'Sede global I&D/centro de dados/vendas Ásia e Austrália',
    },
    dubai: {
      name: 'Dubai',
      subName: 'Escritório regional',
      hovData: 'Equipa de vendas Sudeste Asiático',
    },
    singapore: {
      name: 'Singapura',
      subName: 'Sede',
      hovData: 'Equipa de vendas Sudeste Asiático',
    },
    sanFrancisco: {
      name: 'São Francisco, EUA',
      subName: 'Escritório regional',
      hovData: 'Equipa de vendas América do Norte',
    },
    barcelona: {
      name: 'Barcelona',
      subName: 'Escritório de vendas',
      hovData: 'Sede global I&D/centro de dados/vendas Ásia e Austrália',
    },
  },
};
export default pt;
